import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Link } from 'components/misc/Link'
import Dropdown from './Dropdown'
import classNames from 'classnames'
import styles from './styles/NavCategoryDropdown.css'
import * as analytics from 'lib/analytics'

const MenuItem = ({ label, desc, to, href, onClick }) => {
  const location = useLocation()
  const isActive = to && !to.includes('#') && location.pathname === to

  const handleClick = e => {
    analytics.event({ category: 'Nav Dropdown', action: label })
    if (onClick) onClick(e)
  }

  if (href) {
    return (
      <a href={href} target='_blank' rel='noopener noreferrer' className={styles.menuItem} onClick={handleClick}>
        <span className={styles.itemLabel}>{label}</span>
        <span className={styles.itemDesc}>{desc}</span>
      </a>
    )
  }

  return (
    <Link to={to} className={classNames(styles.menuItem, { [styles.menuItemActive]: isActive })} onClick={handleClick}>
      <span className={styles.itemLabel}>{label}</span>
      <span className={styles.itemDesc}>{desc}</span>
    </Link>
  )
}

const NavCategoryDropdown = ({ title, overviewTo, items, open, setOpen, showDropdownTriangle = false }) => {
  const closeTimer = useRef(null)
  const hovering = useRef(false)
  const cancelClose = () => clearTimeout(closeTimer.current)
  const close = () => {
    cancelClose()
    setOpen(false)
  }

  useEffect(() => () => clearTimeout(closeTimer.current), [])

  const handlePointerEnter = event => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 60em) and (hover: hover)').matches) return
    hovering.current = true
    cancelClose()
    setOpen(true)
  }

  const handlePointerLeave = event => {
    if (event.pointerType !== 'mouse') return
    hovering.current = false
    cancelClose()
    closeTimer.current = setTimeout(() => setOpen(false), 100)
  }

  return (
    <div className={styles.wrapper} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave}>
      <Dropdown
        open={open}
        setOpen={setOpen}
        onTriggerClick={event => setOpen(hovering.current && event.detail > 0 ? true : !open)}
        title={title}
        ariaLabel={title}
        className={styles.dropdown}
        showTriangle={showDropdownTriangle}
        animate
      >
        <div className={styles.items}>
          {items.map(item => (
            <MenuItem key={item.label} {...item} onClick={close} />
          ))}
        </div>
        <Link to={overviewTo} className={styles.viewAll} onClick={close}>
          All {title} →
        </Link>
      </Dropdown>
    </div>
  )
}

export default NavCategoryDropdown
